var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('div',[_c('img',{staticClass:"commodity",attrs:{"src":require("../images/commodity.png")}}),_c('p',{staticClass:"des"},[_vm._v("空空如也，赶紧去逛逛吧！")])])])
}]

export { render, staticRenderFns }